import React from "react"
import { Helmet } from "react-helmet"
import Navigation from "./Navigation"
import config from "../../data/SiteConfig"
import favicon from "../images/favicon.png"
import "../styles/main.scss"

export default ({ children }) => (
  <>
    <Helmet>
      <link rel="shortcut icon" type="image/png" href={favicon} />
    </Helmet>
    <Navigation menuLinks={config.menuLinks} />
    <main id="main-content">{children}</main>
  </>
)
